/* eslint-disable camelcase */
import React from 'react';


export interface IUserInfo{
  completeDegree?: number, // 完简度
  defaultResKind?: string, // 默认简历类型
  goldCardUser?: boolean, // 是否是金卡用户
  resId?: string, // 简历id
  sexName?: string, // 性别
  studentUser?: boolean, // 是否是学生
  userPhoto?: string, // 用户头像
  userName?: string, // 用户真实姓名
  userShowName?: string, // 遵循隐私后的姓名展示
}

export enum EUserInfoLoadState{
  Loading = 'loading',
  Loaded = 'loaded',
  LoadFail = 'loadfail',
  Unload = 'unload'
}

export interface IFrameworkPCState{
  header?: React.ReactNode,
  visibleHeader?: boolean,
  headerClassName?: string,
  quickMenu?: React.ReactNode,
  siderBar?: React.ReactNode,
  visibleSiderBar?: boolean,
  footer?: React.ReactNode,
  visibleFooter?: boolean,
  className?: string,
  defaultSetting?: IFrameworkPCDefaultSetting,
  userInfo?: IUserInfo,
  visibleCity?: boolean,
  userInfoLoadState?: EUserInfoLoadState,
  loading?: boolean,
  visibleSimpleHeader?: any
}

export interface IFrameworkPCDefaultSetting{
  frameworkDefaultVisibleHeader?: boolean,
  frameworkDefaultHeader?: React.ReactNode,
  frameworkDefaultVisibleFooter?: boolean,
  frameworkDefaultFooter?: React.ReactNode,
  frameworkDefaultVisibleSiderBar?: boolean,
  frameworkDefaultSiderBar?: React.ReactNode,
  frameworkDefaultVisibleCity?: boolean
  frameworkDefaultSimpleHeader?: boolean
}

// 需同步：fe/fe-c-pc/v6/src/router/router-map.ts
export enum ERouterMap{
  Home = '/',
  ProfileSecret = '/profile/getsecret/',
  ProfileSecretDesc = '/profile/secret-desc/',
  ResumeDefault = '/resume/getdefaultresume/',
  ResumeReg = '/resume/regresume/',
  ResumeDetail = '/resume/detail/',
  ResumeViewOther = '/resume/view-other/',
  ResumeParsed = '/resume/view-parsed-resume/',
  ResumeComplete = '/resume-complete/page/',
  ResumeViewdLog = '/resume/resumeviewedlog/',
  CreditIntroduction = '/n/credit/introduction/',
  JobLens = '/job/lens/intro/',
  LensDetail = '/lens/detail/',
  FavoriteJob = '/job/favoritesjob/',
  ApplyList = '/apply/applylist/',
  ApplySuccess = '/apply/applySuccess/',
  AtsList = '/apply/ats-list/',
}



export const initFrameworkState: IFrameworkPCState = {
  header: null,
  visibleHeader: true,
  headerClassName: '',
  quickMenu: null,
  siderBar: null,
  visibleSiderBar: true,
  footer: null,
  visibleFooter: true,
  className: '',
  defaultSetting: {},
  userInfo: {},
  visibleCity: false,
  visibleSimpleHeader: '',
  userInfoLoadState: EUserInfoLoadState.Unload,
  loading: false
}
